import * as React from 'react';
import { hydrateRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { QueryClient } from '@tanstack/react-query';
import { App } from './domain/App';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes,
      retry: 3,
      retryDelay: 1500
    },
  },
});

const dehydratedState = (window as any).__REACT_QUERY_STATE__;

const domNode = document.getElementById('app');

if (domNode) {
  hydrateRoot(
    domNode,
    <React.StrictMode>
      <BrowserRouter>
        <App
          queryClient={ queryClient }
          state={ dehydratedState } />
      </BrowserRouter>
    </React.StrictMode>
  );
}
